import {  HttpResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { EAccountServiceCode , EDebitcardServiceCode } from '@common/models';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
// import { HttpProviderService } from '@core/service';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { CommonService } from 'src/app/common.service';
import { IContextualMenu } from 'src/app/common/models/contextual-menu.model';
import { Data } from 'src/app/DataService';
import { AccountDetails } from 'src/app/models/account-info.model';
import { AccTranDetails, TransactionDetail, TransactionInfo } from 'src/app/models/transaction-detail.model';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { ProvidehttpService } from 'src/app/providehttp.service';
import { IChequeDetails } from 'src/app/retail/accounts/cheque-status-inquiry/models/cheque-status-inquiry.model';
import { environment } from 'src/environments/environment';
import { CustomerService } from '../customer.service';
import { HttpRequest, HttpProviderService } from '@fpx/core';

@Injectable({
  providedIn: 'root'
})

export class AccountsService {
  popupData:any;

  private _accountTranInfo:Map<string, TransactionDetail[]> = new Map<string, TransactionDetail[]>();
  public selectedTransaction: {
    accountNumber: string
    transactionRef: string
  }
  nicknames: any[] = [];
  data:any;
  depositdata:any;
  contextualMenuList:IContextualMenu[];
  casaTrxFilterData: {accountNumber:string,filterPayload:any}[] = [];

  constructor(private _customerInfo:CustomerService, private _httpProvider:HttpProviderService,
    public http: ProvidehttpService, private _dataStore:Data,
    private _commonService: CommonService,
    private _customerService: CustomerService,
    private _processShellService: ProcessShellService) {


    }

    setupMenu(){
      this.contextualMenuList = [
        {
          id: "A004",
          icon: "account-details",
          name: "CONTEXTULAMENU.accountDetails",
          title: "CONTEXTULAMENU.accountDetailsTitle",
          path: ["process-shell", "casa-accounts", "accounts-details"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "accounts-details"]
        },
        {
          id: "A008",
          icon: "open-new-casa-account",
          name: "CONTEXTULAMENU.openNewCurrentAccount",
          title: this._commonService.isDesktop()?"CONTEXTULAMENU.openNewCurrentAccountTitle":"CONTEXTULAMENU.openCurrentAccountTitle",
          path: ["process-shell", "casa-accounts", "open-new-ca"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "open-new-ca"],
          serviceCode : EAccountServiceCode.OPEN_NEW_CURRENT_ACCOUNT,
          processCode : 'OPENNEWCA'
        },
        {
          id: "A009",
          icon: "open-new-casa-account",
          name: "CONTEXTULAMENU.openNewSavingsAccount",
          title:  this._commonService.isDesktop()?"CONTEXTULAMENU.openNewSavingsAccountTitle":"CONTEXTULAMENU.openSavingsAccountTitle",
          path: ["process-shell", "casa-accounts", "open-new-sa"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "open-new-sa"],
          serviceCode : EAccountServiceCode.OPEN_NEW_SAVINGS_ACCOUNT,
          processCode : 'OPENNEWSA'
        },
        /*{
          id: "A002",
          icon: "request-demand-draft",
          name: "CONTEXTULAMENU.requestDD",
          title: "CONTEXTULAMENU.requestDemandDraftTitle",
          path: ["process-shell", "casa-accounts", "dd-request"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "dd-request"],
          serviceCode : EAccountServiceCode.REQUEST_DD,
          processCode : 'DDREQ'
        },
        {
          id: "A003",
          icon: "request-account-statement",
          name: "Register for <em>E-Statement</em>",
          title: "CONTEXTULAMENU.requestEStmtTitle",
          // title: "E-Statement registeration",
          path: ["process-shell", "casa-accounts", "estmt-request"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "estmt-request"],
          serviceCode : EAccountServiceCode.REQUEST_E_STATEMENT,
          processCode : 'ESTMTREQ'
        }/** ,
        {
          id: "A001",
          icon: "request-cheque-book",
          name: "CONTEXTULAMENU.requestChequeBook",
          title: "CONTEXTULAMENU.requestChequeBookTitle",
          path: ["process-shell", "casa-accounts", "cheque-book-request"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "cheque-book-request"],
          serviceCode :  EAccountServiceCode.REQUEST_CHECK_BOOK,
          processCode : 'CHQBKREQ',
          // disabled : 'SA'
        },
        {
          id: "A007",
          icon: "inquire-cheque-status",
          name: "CONTEXTULAMENU.inquireChequeStatus",
          title: "CONTEXTULAMENU.inquireChequeStatusTitle",
          path: ["process-shell", "casa-accounts", "cheque-status-enquiry"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "cheque-status-enquiry"],
          serviceCode : EAccountServiceCode.INQUIRE_CHEQUE_STATUS,
          // disabled : 'SA'
        },
        {
          id: "A005",
          icon: "stop-cheque",
          name: "Stop <em>Cheque</em>",
          title: "Stop cheque",
          path: ["process-shell", "casa-accounts", "acc-stop-cheque-request"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "acc-stop-cheque-request"],
          serviceCode : EAccountServiceCode.STOP_CHEQUE,
          processCode : 'STOPCHEQUE',
          // disabled : 'SA'
        },
        {
          id: "A006",
          icon: "revoke-stop-cheque",
          name: "Revoke Stop <em>Cheque</em>",
          title: "Revoke stop cheque",
          path: ["process-shell", "casa-accounts", "acc-stop-cheque-rev-request"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "acc-stop-cheque-rev-request"],
          serviceCode : EAccountServiceCode.REVOKE_STOP_CHEQUE,
          processCode : 'STOPCHEQUEREV',
          // disabled : 'SA'
        },
        {
          id: "A010",
          icon: "account-details",
          name: "Manage <em>Nickname</em>",
          title: "Manage NickName",
          path: ["process-shell", "casa-accounts", "account-nickname"],
          desktopPath: ["home", "transactions", "process-shell", "casa-accounts", "account-nickname"],
          serviceCode : EAccountServiceCode.ACC_NICKNAME,
          processCode : 'ACCNICKNAME',
          queryParams:{
            category:"casa"
          }
        },
        {
          id: "A010",
          icon: "account-details",
          name: "Debit Card Request",
          title: "Debit Card Request",
          path: ["process-shell", "debit-card", "dc-request"],
          desktopPath: ["home","cards","process-shell", "debit-card", "dc-request"],
          serviceCode : EAccountServiceCode.DCREQUEST,
          processCode : 'DCREQUEST'
        }*/
      ];
    }

  /**
   *
   * @param transactionId
   * @returns
   */
  fetchTransactionDetails(transactionId:string){
    this._commonService.showSpinner();

    let transactionDetails: TransactionInfo;
    const httpRequest : HttpRequestPayload = {
      resource : "/transactioninfo/" + transactionId,
      method : "GET"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res : IHttpSuccessPayload<any>) => {
        this._commonService.hideSpinner();
        transactionDetails = res.body['transaction'];
        return transactionDetails;
      }),
      catchError((err : IHttpErrorPayload) => {
        this._commonService.hideSpinner();
        return throwError(err)
    }));
  }

  getMenuList():IContextualMenu[]{
    let menuList = this.contextualMenuList;
    return menuList;
  }

  triggerFormSubmitCopleted(result:any){
    this._processShellService.processId = result?.processId;
    this._processShellService.triggerFormSubmittedCompleteStatus(result);
  }

  getSelectedMenuData(menuId:string){
    const selectedMenuItem = this.contextualMenuList.find(item => item.id == menuId);
    return selectedMenuItem;
  }

  // getList() {
  //   let accounts:any = [];
  //   if(this._customerService.customerInfo.accountInfo.accountDetails) {
  //     accounts = this._customerService.customerInfo.accountInfo.accountDetails;
  //   }
  //   else {
  //     accounts = [].concat(
  //       this._customerService.customerInfo.accountInfo.currentAccounts,
  //       this._customerService.customerInfo.accountInfo.savingsAccounts
  //     )
  //   }
  //   return accounts;
  // }
  
  getList() {
  let accounts: any = [];
  const info = this._customerService.customerInfo.accountInfo;

  if (info.accountDetails) {
    accounts = info.accountDetails;
  } 
  else if (info.currentAccounts?.length > 0 && info.savingsAccounts?.length > 0) {
    accounts = [].concat(info.currentAccounts, info.savingsAccounts);
  }
  else if (info.currentAccounts?.some((acc: any) => acc.accountType === 'CA')) {
    accounts = info.currentAccounts;
  } 
  else if (info.savingsAccounts?.some((acc: any) => acc.accountType === 'SA')) {
    accounts = info.savingsAccounts;
  } 
  return accounts;
}
  /**
   *
   * @param accountNumber
   * @returns
   */
  getAccountSummaryData(accountNumber:string):AccountDetails{
    let selectedAccount:AccountDetails;
    let accountsDetails:AccountDetails[] = [].concat(this._customerInfo.getAccount("CA"),this._customerInfo.getAccount("SA"));
    selectedAccount = accountsDetails.find(item => item.accountNumber == accountNumber);
    return selectedAccount;
  }

  getAccountDetailsData(accountNumber:string):AccountDetails{
    let selectedAccount:AccountDetails;
    let accountsDetails:AccountDetails[] = [].concat(this._customerInfo.getAccount("ALL"));
    selectedAccount = accountsDetails.find(item => item.accountNumber == accountNumber);
    return selectedAccount;
  }

  async loadAccountstatement(accountSummary, merchant, transactionCategory): Promise<any> {
    let accTransactionDetail = [];
    let inputMap = new Map();
    for (var k = 0; k < accountSummary.length; k++) {
      inputMap.clear();
      inputMap.set('PathParam.accountNumber', accountSummary[k].accountNumber);
      await this.http.fetchApi('/transaction/{accountNumber}?recordCount=10&requestedPage=1', 'GET', inputMap, environment.accountsPublisher).toPromise()
        .then(async (httpResponse: HttpResponse<any>) => {
          var transactionDetails:TransactionDetail[];

          if(httpResponse && httpResponse.body) transactionDetails = httpResponse.body.transaction;
          else transactionDetails = [];

          this._accountTranInfo.set(accountSummary[k].accountNumber, transactionDetails);
          let accTranDetails:AccTranDetails;
          if (transactionDetails) {
            accTranDetails = { ...accountSummary[k],  transactionDetails: transactionDetails }
            }
          else {
            accTranDetails = { ...accountSummary[k],  transactionDetails: [] }
          }
          accTransactionDetail.push(accTranDetails);
        },
          async (httpError) => {
            var err = httpError['error']
            if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) { }
          }
        );
    }
    return accTransactionDetail;
  }
  getTransactionInfo(accountNumber:string, transactionRef: string):Observable<TransactionDetail> {
    if(this._accountTranInfo.has(accountNumber)){
      return of(this._accountTranInfo.get(accountNumber).find(item => item.transactionRef == transactionRef));
    }
  }

  /**
   *
   * @param accountNumber
   * @returns
   */
   fetchDetails(accountNumber:string):Observable<AccountDetails>{
    let accountDetails:AccountDetails;

    const httpRequest : HttpRequestPayload = {
      resource : `/casaaccount/${accountNumber}`,
      method : "GET",
      serverContext: environment.accountsPublisher
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res : IHttpSuccessPayload<any>) => {
        accountDetails = res.body['account'];
        return accountDetails;
      }),
      catchError((err : IHttpErrorPayload) => {
        return throwError(err)
    }));
  }

  /**
   *
   * @param accountNumber
   * @description
   * @returns
   */
  getExceptThisAccount(accountNumber:string) {
    const accountsDetails:AccountDetails[] = this._customerInfo.getAccount("CA");
    let exceptThisAccount:AccountDetails[] = accountsDetails.filter(item => item.accountNumber != accountNumber);
    return exceptThisAccount;
  }

  fetchCheques(accountNumber:string):Observable<IChequeDetails[]>{
    let chequeDetails:IChequeDetails[];

    const httpRequest : HttpRequestPayload = {
      resource : `/chequestatus`,
      queryParams: [
        {
          key: 'accountNumber',
          value: accountNumber
        }
      ],
      method : "GET"
    }

    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res : IHttpSuccessPayload<any>) => {
        chequeDetails = res.body;
        return chequeDetails;
      }),
      catchError((err : IHttpErrorPayload) => {
        return throwError(err)
    }));

  }

  shareAccountInfo(selectableData:any){
    let accountNumber=selectableData.accountNumber;
    this.fetchDetails(accountNumber).subscribe({
      next: (account) => {
        let accountInfo:string = `Account holder name: ${account.accountName}\n` +
        `Account number: ${account.accountNumber}\n` +
        `Account type: ${selectableData.accountTypeDesc}\n` +
        `SWIFT Code : ${account.routingCode}`;
        this._dataStore.shareInfo(accountInfo, "Information copied on clipboard!");
      },
      error: (error) => {
        console.error('Account details fetch error');
      }
    });
  }

  fetchAccountsInfo(accountNumber:string):Observable<AccountDetails>{
    let accountDetails:AccountDetails;

    const httpRequest : HttpRequestPayload = {
      // resource : `/casaaccount/${accountNumber}`,
      resource : `/accountnickname/{customerCode}/{inventoryNumber}/${accountNumber}`,
      method : "GET"
    }
    
    return this._httpProvider.invokeApi(httpRequest).pipe(
      map((res : IHttpSuccessPayload<any>) => {
        accountDetails = res.body['casaaccount'];
        return accountDetails;
      }),
      catchError((err : IHttpErrorPayload) => { 
        return throwError(err)
    }));
  }


  async fetchAccountsNickname(){
    const httpRequest = new HttpRequest();
    httpRequest.setResource('/accountnickname');
    httpRequest.setMethod('GET');
    httpRequest.setServerContext(environment.accountsPublisher);
    httpRequest.addPathParameter('userId', this._customerService.customerInfo.customerCode);
    await this._httpProvider.invokeRestApi(httpRequest).subscribe({
      next: (res) => {
        this.nicknames   = res.body.accountnickname
      }
    });
  }

  getNickname(accountNumber:string):string{
    let nickName: string =  this._customerService.nicknames?.find(x=>{
      return x?.accountNumber==accountNumber
    })?.nickName;
    return nickName;
  }

  resetCasaFilter(){
    this.casaTrxFilterData = [];
  }

}
